import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { fetchSingleNewsAssets } from 'b2b-apps/shop/content/redux/newsroom/actionCreators';

type UseFetchSingleNewsAssetsActionReturnType = typeof fetchSingleNewsAssets;

const useFetchSingleNewsAssetsAction = (): UseFetchSingleNewsAssetsActionReturnType => {
  const dispatch = useDispatch();

  return useCallback(
    (entriesIds: string[]): any => {
      dispatch(fetchSingleNewsAssets(entriesIds));
    },
    [dispatch],
  );
};

export type {
  UseFetchSingleNewsAssetsActionReturnType,
};

export {
  useFetchSingleNewsAssetsAction,
};
